<template>
    <CandidatureOffre/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import CandidatureOffre from "@/components/Offre/CandidatureOffre.vue";

    export default defineComponent({
      name: "CandidatureOffrePage",
      components: {
        
        CandidatureOffre,
      },
    });
  </script>